<template>
  <div id="order-comfirm-return-address-new">

    <!-- 标题 -->
    <div class="address-header">
      <div class="header-title">出签回寄</div>
      <img class="icon" src="https://o.666visa.cn/static/ssqpeer/order/express-free.png" alt="">
      <div class="tips">出签后护照、签证页等资料将邮寄至该地址</div>
    </div>

    <!-- 地址列表 -->
    <div class="receive-address-box">

      <div class="address-box">

        <!-- 没有地址 -->
        <div class="add-address-box" @click="showAddressListModel = true" v-if="!address.addressee">
          <img class="icon" src="https://o.666visa.cn/static/ssqpeer/order/address-add.png" alt="">
          <span class="add-address-btn">添加收货地址</span>
        </div>

        <!-- 当前使用地址 -->
        <template v-else>
          <div class="select-address">
            <div class="address-header">
              <div class="address-name">{{address.addressee}}</div>
              <div class="address-phone">{{address.mobile_phone}}</div>
            </div>
            <div class="address-content">
              <div class="address-detail">{{getAddress(pcds, address)}}</div>
              <div class="address-bottom">
                <div class="address-email">
                  <img class="icon" src="https://o.666visa.cn/static/ssqpeer/order/address-email.png" alt="">
                  <span class="email-value">{{address.email}}</span>
                </div>
                <img class="edit-icon" @click.stop="editAddress()" src="https://o.666visa.cn/static/ssqpeer/order/address-edit.png" alt="">
              </div>
            </div>
          </div>
          <div class="selete-other-address" @click="showAddressListModel = true">
            <img class="icon" src="https://o.666visa.cn/static/ssqpeer/order/address-icon.png" alt="">
            <span>使用其它地址</span>
          </div>
        </template>
      </div>
    </div>

    <!-- 地址对话框 -->
    <order-edit-address-modal
      ref="addrModal"
      v-model="addrModel.visible"
      v-if="addrModel.visible"
      :pcds="pcds"
      :addr-modal-title="addrModel.title"
      :address="addrModel.address"
      @edit-success="addressEditSuccess"
    ></order-edit-address-modal>
    <address-list-modal
      v-model="showAddressListModel"
      v-if="showAddressListModel"
      @select-address-success="selectAddressSuccess"
    >
    </address-list-modal>
  </div>
</template>

<script>
import addressUtils from '../../../libs/address-utils';

import orderEditAddressModal from '../modals/order-edit-address-modal';
import addressListModal from '../modals/address-list-modal';
import pcdService from '../../../services/pcd-service';
import productService from '../../../services/product-service';

export default {
  name: 'order-comfirm-return-address',
  components: {
    orderEditAddressModal,
    addressListModal,
  },
  props: {
    address: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    supplierAddress: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    sfReturnExpressPrice: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  data() {
    return {
      supplierProvienceAndCity: '', // 供应商省市
      pcds: {}, // 省市区数据
      addrModel: {
        visible: false, // 显示地址对话框
        title: '订单收货地址', // 地址对话框标题
        address: {}, // 传入的地址
      },
      showAddressListModel: false,
    };
  },
  methods: {
    getAddress: addressUtils.getAddress,

    // 打开新增或者编辑地址
    addressEditSuccess(address) {
      this.$emit('changeReceiveAddress', address);
    },

    // 编辑地址
    editAddress() {
      this.addrModel.visible = true;
      this.addrModel.address = this.address;
    },
    selectAddressSuccess(address) {
      this.$emit('changeReceiveAddress', address);
    },
  },
  watch: {
    supplierAddress(newAddress) {
      if (newAddress && this.pcds) {
        this.supplierProvienceAndCity = productService.setReturnExpressFrom(
          this.pcds, newAddress.province_code, newAddress.city_code);
      }
    },
  },
  created() {
    pcdService.getPcd().then((pcds) => {
      this.pcds = pcds;
      if (this.supplierAddress) {
        this.supplierProvienceAndCity = productService.setReturnExpressFrom(
          this.pcds, this.supplierAddress.province_code, this.supplierAddress.city_code);
      }
    }).catch((e) => {
      if (e) console.log(e);
    });
  },
};
</script>

<style lang="less">
@import  '../../../assets/less/variable';

#order-comfirm-return-address-new {
  background-color: white;
  display: flex;
  flex-direction: column;
  line-height: 1;
  margin-bottom: 20px;

  .address-header {
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 24px;
    border-bottom: 1px solid #E9EEF2;
    .header-title{
      color: #2F333D;
      font-size: 20px;
      font-weight: 600;
      margin-right: 3px;
    }
    .icon{
      width: 43px;
      height: 18px;
      margin-right: 7px;
    }
    .tips{
      color: #91999F;
      font-size: 14px;
    }
  }
  div.receive-address-box {
    padding: 20px 24px;
    div.address-box {
      display: flex;
      .add-address-box{
        width: 300px;
        height: 118px;
        background: #F4F9FF;
        border-radius:2px;
        border:1px dashed rgba(89,159,255,0.87);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .icon{
          width: 15px;
          height: 19px;
          margin-right: 4px;
          margin-top: 2px;
        }
        .add-address-btn{
          color: #599FFF;
          font-size: 14px;
        }
      }
      .select-address{
        border-radius:2px;
        border:2px solid rgba(89,159,255,0.87);
        position: relative;
        z-index: 1;
        width: 300px;
        height: 118px;
        overflow: hidden;
        border-radius:2px;
        background: #fff;
        &::before{
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          z-index: 2;
          width: 100%;
          height: 4px;
          background: url(https://o.666visa.cn/static/ssqpeer/order/address-bar.png) no-repeat left top / cover;
        }
        &::after{
          content: "";
          position: absolute;
          right: -1px;
          top: -1px;
          z-index: 3;
          width: 28px;
          height: 28px;
          background: url(https://o.666visa.cn/static/ssqpeer/order/address-active.png) no-repeat center / 100% 100%;
        }
        &:hover{
          .edit-icon{
            opacity: 1 !important;
          }
        }
        .address-header{
          height: 42px;
          background: #FAFBFC;
          display: flex;
          align-items: center;
          padding: 0 10px;
          .address-name{
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 16px;
            color: #2F333D;
            font-weight: 600;
          }
          .address-phone{
            flex-shrink: 0;
            color: #91999F;
            font-size: 12px;
            margin-left: 8px;
          }
        }
        .address-content{
          padding: 8px 10px;
          .address-detail{
            color: #5F666E;
            font-size: 12px;
            line-height: 18px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            margin-bottom: 6px;
          }
          .address-bottom{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .address-email{
              overflow: hidden;
              display: flex;
              align-items: center;
              .icon{
                width: 12px;
                height: 12px;
                margin-right: 4px;
                flex-shrink: 0;
              }
              .email-value{
                color: #5F666E;
                font-size: 12px;
                line-height: 16px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
            .edit-icon{
              opacity: 0;
              flex-shrink: 0;
              margin-left: 8px;
              width: 14px;
              cursor: pointer;
            }
          }
        }
      }
      .selete-other-address{
        width: 114px;
        height: 118px;
        margin-left: 20px;
        background-color: #FAFBFC;
        border-radius: 2px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #5e9be1;
        .icon{
          width: 18px;
          height: 18px;
          margin-bottom: 8px;
        }
        span{
          font-size: 12px;
          color: #599FFF;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/order-comfirm-return-address.vue